(function ($) {
    $.noConflict();
    $(document).ready(function () {

        /* Megamenu */
      $(".site-nav li.is-focused").mouseover(function () {
            $('.site-nav__dropdown').show('fast');
        }).mouseout(function () {
            $('.site-nav__dropdown').hide('fast');
        });

        /* Hide sidebar if blog products are empty */
        if ($('.blogProductBlock').length == 0) {
            $('#shopify-section-blog-sidebar, #shopify-section-blog-sidebar-top-gifts').hide();
        } else {
            $('#shopify-section-blog-sidebar, #shopify-section-blog-sidebar-top-gifts').show();
        }

        /* Full Width Blog Posts No Sidebar */
        if ($('.blogSidebar').length == 0){
            $('.blogProductsContainer').css('width', '100%');
        } else {
            $('.blogProductsContainer').css('width', '70%');
        }

        /* Toggle Sidebar */
        $('.blogSidebarToggle').click(function() {
            $(this).next('.blogSidebar ul').slideToggle();
            $(this).find('i').toggleClass("blogSidebarToggleIconClose");
        });

        $('.blogSidebarTitle:nth-child(3)').click(function(){
            $('.blogTags').slideToggle();
            $(this).find('i').toggleClass("blogSidebarUpArrow");
        });

        $('.blogSidebarMobileToggle').click(function() {
            $('.blogSidebar .mobileParent').slideToggle();
            $(this).find('i').toggleClass("blogSidebarToggleIconClose");
        });

        /*** Sub-Navigation Mobile ***/
        $('#navLandingLink').on("click", function () {
            $('.sub-nav-mobile__content').toggleClass("hide");
          


        });

        $('#arrow-1').on("click", function () {
            $('#dropdown-menu-1').toggleClass("hide");
            $('#arrow-1').toggleClass("up");
        });

        $('#arrow-2').on("click", function () {
            $('#dropdown-menu-2').toggleClass("hide");
            $('#arrow-2').toggleClass("up");
        });

        $('#arrow-3').on("click", function () {
            $('#dropdown-menu-3').toggleClass("hide");
            $('#arrow-3').toggleClass("up");
        });

        $('#arrow-4').on("click", function () {
            $('#dropdown-menu-4').toggleClass("hide");
            $('#arrow-4').toggleClass("up");
        });

        $('#arrow-5').on("click", function () {
            $('#dropdown-menu-5').toggleClass("hide");
            $('#arrow-5').toggleClass("up");
        });

        $('#arrow-6').on("click", function () {
            $('#dropdown-menu-6').toggleClass("hide");
            $('#arrow-6').toggleClass("up");
        });

        $('#arrow-7').on("click", function () {
            $('#dropdown-menu-7').toggleClass("hide");
            $('#arrow-7').toggleClass("up");
        });

        $('#arrow-8').on("click", function () {
            $('#dropdown-menu-8').toggleClass("hide");
            $('#arrow-8').toggleClass("up");
        });

        $('#arrow-9').on("click", function () {
            $('#dropdown-menu-9').toggleClass("hide");
            $('#arrow-9').toggleClass("up");
        });

        $('#arrow-10').on("click", function () {
            $('#dropdown-menu-10').toggleClass("hide");
            $('#arrow-10').toggleClass("up");
        });

        /*** Hide Profanity Filter  ***/

        $('.snow-form').on('keydown', function(event) {
    
                setTimeout(function(){
                    let charLimit = event.target.maxLength;
                    let inputLength = event.target.value.length;
                    let charRemaining = charLimit - inputLength;
                    let inputLine = event.target.dataset.input;
                
                $(`.characters-remaining.${inputLine}`).text(`${charRemaining} characters left`);

                    
                }, 10)
                
                setTimeout(function(){
                    let inputValue = event.target.value
                    let inputLine = event.target.dataset.input;
                    debugger
                    if ((inputValue.length > 0  && !hasCharacters(inputValue))){
                        $( ".empty-spaces-alert" ).addClass("show");
                        $("button#AddToCart-product-template").prop('disabled', true);
                        $("div.shopify-payment-button__button").prop('disabled', true);
                    } else if(isProfanity(inputValue)){
                    
                        $( ".profanity-alert" ).addClass("show");
                        $("button#AddToCart-product-template").prop('disabled', true);
                        $("div.shopify-payment-button__button").prop('disabled', true);
                    
                    } else {
                    $( ".empty-spaces-alert" ).removeClass("show");
                        $( ".profanity-alert" ).removeClass( "show" )
                        $("button#AddToCart-product-template").prop('disabled', false);
                        $("div.shopify-payment-button__button").prop('disabled', false);
                    }

                    
                }, 10)
            
            });
            
            
            function isProfanity(phrase) {
                let isProfane = false;
                let profanityPhrases = ['fuck', 'dick', 'dickhead', 'shit', 'asshole', 'dick', 'cock', 'penis', 'cunt', 'bitch', 'whore', 'slut', 'nigger', 'nigga', 'vagina', 'pussy', 'faggot', 'piss', 'fag', 'bastard', 'ass']

                profanityPhrases.forEach(profanity => {
                    if (phrase.includes(profanity)){
                        isProfane = true;
                    }
                })
                return isProfane;
            }
            
            
            function hasCharacters(phrase) {
            let hasLetters = false;
            phrase.split("").forEach(character => {
                if (character !== " "){
                    hasLetters = true;
                }
                })
            return hasLetters;
            }


    });

    new WOW().init();

})(jQuery);